import { Suspense, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Protected } from '../../../../auth';
import { LoaderOverlay } from '../../../../components';
import UserModuleNav from '../../../../components/nav';
import { Footer, Header } from '../../../../layout';
import { PageHeaderProvider, usePageHeaderState } from '../../../../utils/page-header-context';

function HomeShell() {
  const location = useLocation();
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const { className, headerLeftContent, headerRightContent } = usePageHeaderState();

  const isChat = location.pathname === '/chat' || location.pathname.startsWith('/chat/');

  useEffect(() => {
    setIsAdmin(location.pathname.includes('system-admin'));
  }, [location.pathname]);

  return (
    <div className="flex h-screen min-h-0">
      {!isAdmin && <UserModuleNav />}
      <div className="flex-1 flex flex-col min-w-0 bg-[#F4F7FE]">
        <Header leftContent={headerLeftContent} rightContent={headerRightContent} />
        <main
          className={`relative flex-1 min-w-0 overflow-y-auto overflow-x-hidden flex flex-col bg-gray-50 ${className} px-4 pt-4 scrollbar-hide`}
        >
          <Protected>
            <Suspense fallback={<LoaderOverlay scoped />}>
              <Outlet />
            </Suspense>
          </Protected>
        </main>
        {!isChat && <Footer />}
      </div>
    </div>
  );
}

/** Persistent app shell – stays mounted while navigating between pages. */
function Home() {
  return (
    <PageHeaderProvider>
      <HomeShell />
    </PageHeaderProvider>
  );
}

export default Home;
